<template>
  <div>
    <!-- ── Navigation Drawer (Sidebar) ── -->
    <v-navigation-drawer v-model="sidebarVisible" app temporary :dark="isDark"
      class="sys-drawer">
      <!-- Header del drawer -->
      <div class="drawer-header">
        <img :src="hermandadLogo" alt="Logo" class="drawer-logo" />
        <span class="drawer-brand">{{ hermandadName }}</span>
      </div>

      <div class="drawer-divider"></div>

      <v-list nav dense class="drawer-list">
        <!-- Inscripción -->
        <v-list-group prepend-icon="mdi-account-group" no-action value="true"
          active-class="drawer-item--active" class="drawer-group">
          <template v-slot:activator>
            <v-list-item-title class="drawer-group__title">Inscripción</v-list-item-title>
          </template>
          <v-list-item @click="navigate('/dashboard')" active-class="drawer-item--active" class="drawer-item">
            <v-list-item-title>Inicio</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigate('/inscripciones')" active-class="drawer-item--active" class="drawer-item">
            <v-list-item-title>Cargadores</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigate('/inscribir')" active-class="drawer-item--active" class="drawer-item">
            <v-list-item-title>Inscribir</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <div class="drawer-divider drawer-divider--sm"></div>

        <!-- Turnos -->
        <v-list-group prepend-icon="mdi-calendar-clock" no-action
          active-class="drawer-item--active" class="drawer-group">
          <template v-slot:activator>
            <v-list-item-title class="drawer-group__title">Turnos</v-list-item-title>
          </template>
          <v-list-item @click="navigate('/turnos')" active-class="drawer-item--active" class="drawer-item">
            <v-list-item-title>Asignación de turnos</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <div class="drawer-divider drawer-divider--sm"></div>

        <!-- Administración -->
        <v-list-group prepend-icon="mdi-cog" no-action
          active-class="drawer-item--active" class="drawer-group">
          <template v-slot:activator>
            <v-list-item-title class="drawer-group__title">Administración</v-list-item-title>
          </template>
          <v-list-item @click="navigate('/procesiones')" active-class="drawer-item--active" class="drawer-item">
            <v-list-item-title>Procesiones</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <!-- Footer del drawer -->
      <template v-slot:append>
        <div class="drawer-footer">
          <span class="drawer-footer__text">© 2026 CucuruchoOnline</span>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- ── App Bar ── -->
    <v-app-bar app elevation="0" class="sys-appbar">
      <v-app-bar-nav-icon @click.stop="sidebarVisible = !sidebarVisible"
        class="sys-appbar__menu-icon">
      </v-app-bar-nav-icon>

      <!-- Logo + hermandad en el centro-izquierda -->
      <div class="sys-appbar__brand">
        <img :src="hermandadLogo" alt="Logo" class="sys-appbar__logo" />
        <span class="sys-appbar__name d-none d-sm-flex">{{ hermandadName }}</span>
      </div>

      <v-spacer></v-spacer>

      <button class="appbar-icon-btn" @click="toggleTheme()" title="Cambiar Tema">
        <v-icon small :style="{ color: isDark ? '#eab308 !important' : '#334155 !important' }">
          {{ isDark ? 'mdi-weather-sunny' : 'mdi-weather-night' }}
        </v-icon>
      </button>

      <!-- Selector de procesión -->
      <button class="appbar-proc-btn" @click="activaDialogProc()">
        <v-icon small class="mr-1 theme-icon">mdi-arrow-down-drop-circle</v-icon>
        <span class="appbar-proc-btn__text d-none d-sm-flex">{{ procesion || 'Seleccionar procesión' }}</span>
      </button>

      <!-- Cerrar sesión -->
      <button class="appbar-logout-btn" @click="logout()">
        <v-icon small class="theme-icon">mdi-logout</v-icon>
        <span class="d-none d-sm-flex">Cerrar Sesión</span>
      </button>
    </v-app-bar>

    <!-- ── Dialog Procesiones ── -->
    <v-dialog v-model="dialogProcesion" max-width="480px" persistent>
      <div class="sys-dialog">
        <div class="sys-dialog__header">
          <span class="sys-dialog__title">Seleccionar Procesión</span>
          <p class="sys-dialog__sub">Elegí la procesión que deseas gestionar</p>
        </div>
        <div class="sys-dialog__body">
          <v-combobox
            v-model="selectedProcesion"
            :items="procesiones"
            label="Procesión"
            item-text="label"
            item-value="ID_Procesion"
            :dark="isDark"
            outlined
            dense
            class="sys-combobox"
          ></v-combobox>
        </div>
        <div class="sys-dialog__actions">
          <button class="sys-btn sys-btn--ghost" @click="cancel" v-if="procesion">Cancelar</button>
          <button class="sys-btn sys-btn--primary" @click="setProcesion" :disabled="!selectedProcesion">Hecho →</button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "@/utils/eventBus";

export default {
  data() {
    return {
      sidebarVisible: false,
      dialogProcesion: false,
      procesiones: [],
      selectedProcesion: null,
      procesion: "",
      hermandadName: "CucuruchoOnline",
      hermandadLogo: "/logo.ico",
    };
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    }
  },
  mounted: function () {
    this.hermandadName = this.$cookies.get("hermandad") || "CucuruchoOnline";
    this.hermandadLogo = this.$cookies.get("logo") || "/logo.ico";

    if (this.$cookies.get("ProcesionID") == null) {
      this.obtieneProcesiones();
    }
    this.procesion = this.$cookies.get("Procesion");
  },
  methods: {
    toggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      const theme = this.$vuetify.theme.dark ? 'dark' : 'light';
      localStorage.setItem('theme', theme);
      document.documentElement.setAttribute('data-theme', theme);
    },
    setProcesion() {
      if (!this.selectedProcesion) return;
      const selectedProcesionId = this.selectedProcesion.ID_Procesion;
      const selectedProcesionDesc = this.selectedProcesion.Descripcion;
      const selectedProcesionCostoCargador = this.selectedProcesion.Costo_Inscripcion;
      const selectedProcesionCostoAspirante = this.selectedProcesion.Costo_Aspirante;
      const selectedProcesionCostoS = this.selectedProcesion.Costo_honors;
      const selectedProcesionCostoE = this.selectedProcesion.Costo_honore;
      if (selectedProcesionId !== null) {
        this.$cookies.set("ProcesionID", selectedProcesionId);
        this.$cookies.set("Procesion", selectedProcesionDesc);
        this.$cookies.set("ProcesionCost", selectedProcesionCostoCargador);
        this.$cookies.set("ProcesionACosto", selectedProcesionCostoAspirante);
        this.$cookies.set("ProcesionSCost", selectedProcesionCostoS);
        this.$cookies.set("ProcesionECost", selectedProcesionCostoE);
        this.dialogProcesion = false;
        this.procesion = selectedProcesionDesc;
        if (this.$route.path !== "/dashboard") {
          this.$router.push("/dashboard").then(() => {});
        } else {
          EventBus.$emit("procesionChanged");
        }
      }
    },
    async obtieneProcesiones() {
      while (!this.$cookies.get("username") || !this.$cookies.get("token")) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
      const apiUrl = `https://hk32hsqoo6.execute-api.us-east-1.amazonaws.com/dev/api/procesiones?usuarioResponsable=${this.$cookies.get("username")}&incluirDesactivadas=false`;
      const token = this.$cookies.get("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      axios
        .get(apiUrl, config)
        .then((response) => {
          if (response.data?.records?.length > 0) {
            this.procesiones = response.data.records.map((procesion) => ({
              ...procesion,
              label: `${procesion.Descripcion} - ${procesion.Fecha}`,
            }));
            this.dialogProcesion = true;
          } else {
            this.loading = false;
            if (this.$route.path !== "/procesiones") {
              this.$router.push("/procesiones");
            }
          }
        })
        .catch(() => {});
    },
    cancel() {
      this.dialogProcesion = false;
    },
    activaDialogProc() {
      this.obtieneProcesiones();
      this.dialogProcesion = true;
    },
    navigate(route) {
      this.sidebarVisible = false;
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    logout() {
      this.clearAllCookies();
      this.$router.push("/sistema");
    },
    clearAllCookies() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

/* ── APP BAR ── */
.sys-appbar {
  background: var(--sys-card-bg) !important;
  backdrop-filter: blur(12px) !important;
  border-bottom: 1px solid var(--sys-card-border) !important;
  font-family: 'Inter', sans-serif !important;
}

.theme-icon {
  color: var(--sys-text-primary) !important;
}

.sys-appbar__menu-icon {
  color: var(--sys-text-primary) !important;
}

.sys-appbar__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 4px;
}
.sys-appbar__logo {
  height: 32px;
  width: auto;
  border-radius: 6px;
}
.sys-appbar__name {
  color: var(--sys-text-primary);
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.02em;
}

/* Botón procesión & icono */
.appbar-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid var(--sys-card-border);
  border-radius: 8px;
  width: 34px; height: 34px;
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 12px;
}
.appbar-icon-btn:hover {
  background: var(--sys-input-bg);
}

.appbar-proc-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--sys-drawer-active);
  border: 1px solid var(--sys-card-border);
  border-radius: 20px;
  padding: 6px 14px;
  color: var(--sys-text-primary);
  font-family: 'Inter', sans-serif;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 10px;
}
.appbar-proc-btn:hover {
  background: var(--sys-drawer-active);
  border-color: rgba(123,47,247,0.6);
}
.appbar-proc-btn__text {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Botón logout */
.appbar-logout-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid var(--sys-card-border);
  border-radius: 8px;
  padding: 6px 14px;
  color: var(--sys-text-secondary);
  font-family: 'Inter', sans-serif;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.appbar-logout-btn:hover {
  background: var(--sys-input-bg);
  color: var(--sys-text-primary);
  border-color: var(--sys-text-secondary);
}

/* ── DRAWER ── */
.sys-drawer {
  background: var(--sys-drawer-bg) !important;
  border-right: 1px solid var(--sys-card-border) !important;
  font-family: 'Inter', sans-serif !important;
}

.drawer-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 16px 16px;
}
.drawer-logo {
  height: 36px;
  width: auto;
  border-radius: 6px;
}
.drawer-brand {
  font-size: 1rem;
  font-weight: 700;
  color: var(--sys-text-primary);
}

.drawer-divider {
  height: 1px;
  background: var(--sys-card-border);
  margin: 0 16px;
}
.drawer-divider--sm {
  margin: 6px 16px;
}

.drawer-list {
  padding: 8px 0;
}

.drawer-group {
  margin: 2px 0;
}

.drawer-group__title {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--sys-text-primary);
}

.drawer-item {
  border-radius: 8px;
  margin: 2px 8px;
  transition: background 0.2s;
}

.drawer-item--active {
  background: var(--sys-drawer-active) !important;
  color: #7b2ff7 !important;
}
[data-theme="dark"] .drawer-item--active {
  color: #c4a0ff !important;
}

.drawer-footer {
  padding: 16px;
  border-top: 1px solid var(--sys-card-border);
}
.drawer-footer__text {
  font-size: 0.78rem;
  color: var(--sys-text-secondary);
}

/* ── DIALOG ── */
.sys-dialog {
  background: var(--sys-dialog-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 18px;
  padding: 32px 28px;
  font-family: 'Inter', sans-serif;
}

.sys-dialog__header {
  margin-bottom: 24px;
}
.sys-dialog__title {
  font-size: 1.3rem;
  font-weight: 800;
  color: var(--sys-text-primary);
  display: block;
  margin-bottom: 6px;
}
.sys-dialog__sub {
  font-size: 0.88rem;
  color: var(--sys-text-secondary);
  margin: 0;
}

.sys-dialog__body {
  margin-bottom: 24px;
}

.sys-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.sys-btn {
  padding: 10px 22px;
  border-radius: 10px;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.sys-btn--primary {
  background: linear-gradient(135deg, #7b2ff7, #4a1b9a);
  color: #fff;
  box-shadow: 0 4px 14px rgba(123,47,247,0.35);
}
.sys-btn--primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(123,47,247,0.5);
}
.sys-btn--primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.sys-btn--ghost {
  background: transparent;
  color: var(--sys-text-secondary);
  border: 1px solid var(--sys-card-border);
}
.sys-btn--ghost:hover {
  background: var(--sys-input-bg);
  color: var(--sys-text-primary);
}
</style>
